import { render } from "./DataExportProgressor.vue?vue&type=template&id=21126887"
import script from "./DataExportProgressor.vue?vue&type=script&lang=js"
export * from "./DataExportProgressor.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__